import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div data-testid="not-found" className="min-h-[70vh] flex items-center pt-28">
      <div className="mx-auto max-w-[1440px] px-6 md:px-10">
        <div className="kbd">— 404</div>
        <h1 className="mt-6 font-serif text-6xl md:text-9xl tracking-tightest">Not found.</h1>
        <p className="mt-6 text-ink-muted max-w-lg">This page doesn't exist yet. The site is under active build for Batch 1 — try returning home.</p>
        <Link to="/" className="btn-pill-inv mt-10">Back to home</Link>
      </div>
    </div>
  );
}
